var mql = window.matchMedia("only screen and (max-width: 768px)");

mediaqueryresponse(mql);
mql.addEventListener('change', mediaqueryresponse);

function mediaqueryresponse(mql) {
    if (mql.matches) { // Mobile JS
      moveElements()
    }
}

function moveElements() {
  const mobileHeader = document.getElementById('product__mobile-intro');
  const elementsToReplace = document.querySelectorAll('.product__info-wrapper .position-above-image');
  if (mobileHeader) {
    elementsToReplace.forEach(element => {
      mobileHeader.append(element);
    });
  }
  
}
  